
import request from '@/utils/request'

export function getSalesReport(id) {
  return request({
    url: `/api/SalesReport/GetSalesReport?id=${id}`
  })
}

export function getSalesHomeReport() {
  return request({
    url: `/api/SalesReport/GetSalesHomeReport`
  })
}

export function receivedSalesHomeReport(id) {
  return request({
    url: '/api/SalesReport/ReceivedSalesHomeReport?id=' + id,
    method: 'post',
    header: {
      'Content-Type': 'application/json;charset=utf-8'  //如果写成contentType会报错
    },

  })
}